import { fun_PostAction, fun_Download } from "@/api";
import { fun_DownloadFile } from "@/utils/validate";

// 导出
export default {
  // 数据存储
  data: () => {
    // 返回
    return {
      // 默认关闭弹窗
      dialogVisible: false,
      // 主键
      id: null,
      // ids
      basicInfoId: null,
      // 招标代理备案表主键
      agencyId: null,
      // 默认不显示
      isShow: false,
      // 是否显示资格预审的按钮
      showBtn: true,

    };
  },
  
  // 注册组件
  components: {
  },
  // 自定义方法
  methods: {
    /**
     * 点击的事件
     */
    fun_Eva(e) {
      // 调用父方法
      this.$parent.fun_FileLook(e,this.basicInfoId);
      // 关闭弹出框
      this.dialogVisible = false;
    },

    /**
     * 弹窗关闭的事件
     * @author shuhua
     */
    fun_HandleClose() {
      // 重置值
      this.isShow = false;
      // pdf路径
      this.pdfUrl = null;
    }
  }
};
